/** A whole number (rupees, display order) typed into a text input, or null when it isn't one. */
export function parseWhole(value: string): number | null {
  const t = value.trim();
  return /^\d+$/.test(t) ? Number(t) : null;
}
